module.exports = __webpack_public_path__ + "static/background-143e3c9afe9e81a936b6f0daaaebc4ca.png";